export default __webpack_public_path__ + "static/media/style-mobile.bf8f3c35.jpg";